export const ExportType = {
  PRINT: "Print",
  EMAIL: "Email",
  DOWNLOAD_PDF: "Download Pdf",
  VIEW_PDF: "View Pdf",
  PREVIEW_PDF: "Preview Pdf",
};
